import React, { FC } from 'react'
import { BrandIconProps } from './BrandIcon.types'
import { setTextAlignment } from '../../../../../utils/text-util'
import { APIENDPOINT, getCWPEnvironmentForURL } from '../../../../../utils/common-utils'
import {
  setBrandIconClass,
  brandIconSize,
  setFillThemeVarColor,
} from '../../../../../utils/brand-icons-utils'
import { RTECompound } from '../../RTECompound'

import './BrandIcon.module.scss'

export const BrandIcon: FC<BrandIconProps> = props => {
  const {
    iconsDropdown,
    iconsColorsDropdown,
    alignment,
    enableBorder,
    className,
    stylesDropdown,
    size,
    identifier,
    testId,
    shouldGrow,
    label,
  } = props

  const env = getCWPEnvironmentForURL(window.location.href)

  const setBrandIconBorder = () => {
    if (stylesDropdown?.endsWith('brand-icons-fill-colors') && enableBorder) {
      return (
        <style
          type='text/css'
          dangerouslySetInnerHTML={{
            __html: `
            #icon-${identifier} .BrandIconsComponent--icon { border: 2px solid ${setFillThemeVarColor(
              iconsColorsDropdown ?? ''
            )}; }
        `,
          }}
          role='presentation'
        />
      )
    } else return
  }

  return (
    <>
      {iconsDropdown && (
        <>
          {setBrandIconBorder()}
          <div
            className={`${setTextAlignment(
              alignment ?? ''
            )} BrandIconsComponent u-paddingBottom2gu u-block ${className}${
              shouldGrow ? ' u-flexGrow' : ''
            }`}
            id={`icon-${identifier}`}
            data-testid={testId ? `${testId}-icon` : null}>
            <div className='u-flexInline u-flexAlignItemsCenter'>
              <svg
                className={`BrandIconsComponent--icon ${
                  iconsColorsDropdown ?? ''
                } ${setBrandIconClass(
                  stylesDropdown,
                  enableBorder,
                  iconsColorsDropdown
                )} ${brandIconSize(size ?? 'u-sizeDefault')}`}
                aria-hidden='true'
                data-testid={testId ? `${testId}-svg` : null}>
                <use
                  href={`${
                    APIENDPOINT(env).baseGallery
                  }content/gallery/ampmicrosites/brand-icons/icon-sprite.svg#${iconsDropdown}`}
                  data-testid={testId ? `${testId}-svg-use` : null}
                />
              </svg>
              {label && (
                <div className={'u-paddingLeft2gu'}>
                  <RTECompound {...label} />
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  )
}
